import React from "react";

import { Button, Form } from "antd";
import "./FormButtons.css";

export default function FormButtons({
  nextButtonText = "Next",
  backButtonText = "Previous",
  handleBack,
  showBack = true,
  loading = false,
  nextDisabled = false,
}) {
  return (
    <Form.Item className="FormButtons">
      {showBack && (
      <Button
        type="default"
        onClick={handleBack}
        disabled={loading}
      >
        {backButtonText}
      </Button>
      )}
      <Button
        type="primary"
        htmlType="submit"
        loading={loading}
        disabled={nextDisabled}
      >
        {nextButtonText}
      </Button>
    </Form.Item>
  );
}
